import { Button } from '../../components/Button/NewButton';
import { useState } from 'react';
import { CsvImportColumn } from '../../lib/csv';
import { GetApp } from '@material-ui/icons';
import { CSVImportModal } from './Settings/CSVImportModal';

export interface CsvImportProps<T> {
  canOverwrite: boolean;
  hideOverwriteMessage?: boolean;
  settingName: string;
  requiredColumns: CsvImportColumn[];
  onImport(csv: Array<T>, overwrite: boolean): void;
}

function CsvImportButton<T>(props: CsvImportProps<T>) {
  const [importOpen, setImportOpen] = useState(false);

  return (
    <>
      <Button
        color="inherit"
        onClick={() => setImportOpen(true)}
        startIcon={<GetApp fontSize="small" />}
        theme="text"
        typeCasing="capitalize"
      >
        Import
      </Button>
      <CSVImportModal<T>
        open={importOpen}
        onClose={() => setImportOpen(false)}
        {...props}
      />
    </>
  );
}
export { CsvImportButton };
